import { resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f2608ac")

_pushScopeId("data-v-6f2608ac")
const _hoisted_1 = { class: "section-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "section-title" }, "Project Background", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "section-title" }, "My role in this project", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"section-row\" data-v-6f2608ac><h3 class=\"section-title\" data-v-6f2608ac>Payment Handling</h3><h4 class=\"section-title\" data-v-6f2608ac>Complex workflow of components</h4></div><div class=\"section-row\" data-v-6f2608ac><h3 class=\"section-title\" data-v-6f2608ac>Biggest Lessons Learned</h3></div><div class=\"section-row\" data-v-6f2608ac><h3 class=\"section-title\" data-v-6f2608ac>Summary</h3></div>", 3)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CoverImage = _resolveComponent("CoverImage")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_CoverImage, {
      url: `/images/projects/${_ctx.project.thumbnail}`
    }, null, 8, ["url"]),
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_Carousel, {
        "items-to-show": "5",
        paths: _ctx.imagesPaths
      }, null, 8, ["paths"])
    ]),
    _hoisted_4
  ], 64))
})